import HmEventRegistry from './../model/HmEventRegistry';
import HawkEye from './HawkEye';
import TrackingManager from '../model/event-structures';
import UrlManager from '../model/UrlManager';

var IcePieTracker = function(){
	var me = this;
	var userStore = null;

	var sourceMap = function(){
		var sourceActionMap = {"um":"SESSION_CHECK","plp":"GET_PLP_TOPICS"}	

		for(var i in sourceActionMap){
			sourceActionMap[i] = UrlManager.getDomainForAction(sourceActionMap[i]);
		}

		return sourceActionMap;
	}();

	var post = function(trackObj){
		try{
		//console.log("trackObj :::::", trackObj);
		if(trackObj){
			var output = {"event":trackObj};
			new HawkEye(output).post();
		}
	}catch(e){
		console.error(e);
	}
}

var processEnumSubstitution = function(tObj){
	if(tObj){
		try{
			if(tObj.enum_key && tObj.enum_replace_key && tObj.enum_replace_value){
				var actualVal =TrackingManager.enums[tObj.enum_replace_key][tObj.enum_replace_value];
				tObj[tObj.enum_key] = actualVal;
				delete tObj.enum_key; 
				delete tObj.enum_replace_value; 
			}

			if(tObj.url){
				var actualVal = extractSrcFromUrl(tObj.url,tObj.enum_replace_key);
				tObj["source"] = actualVal;
			}

			delete tObj.enum_replace_key;
			delete tObj.url;
		}catch(e){
			console.error(e);
		}
	}

	return tObj;
}

var initTrack = function(trackKey, addnldata){
	try{
		var trackObj = TrackingManager.getEventObject(TrackingManager.eventCodes[trackKey]);
		trackObj.event_details.user_id = (userStore && userStore.getUserId) ? userStore.getUserId() : "";
		trackObj.event_details.session_id = (userStore && userStore.getAuthToken) ? userStore.getAuthToken() : "";
		trackObj.event_details.timestamp = new Date().getTime() || "";

		if(addnldata !== undefined && typeof addnldata === "object"){
			addnldata = processEnumSubstitution(addnldata);

			for(var key in addnldata){
				trackObj.event_data[key] = addnldata[key];
			}
		}


		post(trackObj);
	}catch(e){
		console.error(e);
	}
}


var extractSrcFromUrl = function(url, enumKey){
	try{
		if(!enumKey){
			enumKey = "encounteredErrorSource";
		}

		if(url && url.length > 0){
			for(var i in sourceMap){
				if(url.indexOf(sourceMap[i]) > -1){
					return TrackingManager.enums[enumKey][i];
				}
			}
		}
	}catch(e){}

	return -1;
}

return{
	setStore:function(store){
			//console.log("store ::::", store);
			if(store)
				userStore = store;

			return me;
		},
		track:function(trackKey, addnldata){
			//console.log("tracker data ::::", trackKey, addnldata);
			initTrack(trackKey, addnldata);
		}
	}
}();

export default IcePieTracker;

HmEventRegistry.registerEvent("TRACK_EVENT",function(trackKey, addnldata, store){
	if(store){
		IcePieTracker.setStore(store).track(trackKey, addnldata);
	}else{
		IcePieTracker.track(trackKey, addnldata);	
	}	
});

HmEventRegistry.registerEvent("SET_TRACK_STORE",function(store){
	if(store){
		IcePieTracker.setStore(store);
	}	
});


// WEBPACK FOOTER //
// ./src/util/IcePieTracker.js